import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { mailItem } from '../stores/mailbox'

import MailItem from "./MailItem";
import axiosInstance from "../libs/axiosInstant";
import {useQuery} from "react-query";
import numeral from "numeral";
import PerfectScrollbar from 'perfect-scrollbar';
import {Link, useParams} from "react-router-dom";
import * as $ from "jquery"
import Avatar from "./Avatar";
import useMoveMutation from "../libs/MoveHandler";
import {Tooltip} from "bootstrap";

const Mailbox = () => {
    const {reload, moveId, mailItemOpen, mailID, labels, label, config : {user}} = useSelector((state) => state.mailBox)
    const dispatch = useDispatch()

    const [checkedItems, setCheckedItems] = useState([]);

    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState(null);
    let { slug } = useParams();
    slug = (typeof slug === 'undefined') ? label : slug;

    const handleItem = (ele, id) => {
        dispatch(mailItem({id, open: true}));
        const el = $(ele.target).closest('.mail-item')
        //el.addClass('active').siblings().removeClass('active');
        el.removeClass('unread');

        $('.mailcontent-placeholder').siblings().removeClass('d-none');
        $('.mailcontent-placeholder').addClass('d-none');

        if (window.matchMedia('(max-width: 1199px)').matches) {
            $('body').addClass('mailcontent-show');
        }
    }

    const fetchMessages = async (label, page = 1, search) => {
        const { data } = await axiosInstance.get(`/inbox/messages/${label}?page=${page}&q=${search}`)
        setMeta(data.meta);
        return data;
    }

    const { isLoading, isError, data, refetch } = useQuery(['messages', slug, page, search, reload], () => fetchMessages(slug, page, search))

    const mailItemsRef = useRef(null); // Reference to the scroll container
    useEffect(() => {
        const ms = new PerfectScrollbar(mailItemsRef.current);
        return () => {
            ms.destroy();
        }
    }, []);

    useEffect(() => {
        setPage(1);
        dispatch(mailItem({id: null, open: false}));
    }, [slug]);


    const [checkAll, setCheckAll] = useState(0);
    const deleteItemsRef = useRef(null);
    const checkAllRef = useRef(null);
    const handleCheckAll = (e) => {
        e.preventDefault();
        checkAllRef.current.classList.toggle('checkall');
        deleteItemsRef.current.classList.toggle('d-none');

        $('#mailGroup .mail-item').toggleClass('selected').find('input').attr('checked', !checkAll);
        setCheckAll(!checkAll)

        setCheckedItems(data.rows.map(r => r.id))
    }

    const { moveHandle } = useMoveMutation();
    const handleDelete = (e) => {
        e.preventDefault();
        moveHandle(null, 'trash', checkedItems, true)
        deleteItemsRef.current.classList.toggle('d-none');
        refetch()
    }

    useEffect(() => {

        $('.mailbox-menu').on('click', function(e){
            e.preventDefault();
            if (window.matchMedia('(max-width: 767px)').matches) {
                $('body').toggleClass('sidebar-show');
            } else {
                $('body').toggleClass('sidebar-hide');
            }
            //mc.update();
        });

        $('.backdrop').on('click', function(e){
            $('body').removeClass('sidebar-show');
        });

        $('.mail-item [type=checkbox]').on('checked', (e) => {
            handleCheckAll(e)
        })
        $('.mailbox-select').on('mouseenter mouseleave', '.dropdown-check, .dropdown-link', function(e){
            if(e.type === 'mouseenter') {
                $(this).parent().addClass('onhover');
            } else {
                $(this).parent().removeClass('onhover');
            }
        });

        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach((tooltipTriggerEl) => {
            new Tooltip(tooltipTriggerEl);
        });

        return () => {
            $('.mailbox-menu').off('click');
            $('.mailbox-select').off('click');
            $('.backdrop').off('click');
        }
    }, []);

    useEffect(() => {
        setCheckedItems([]);
        setCheckAll(0);
        checkAllRef.current.classList.remove('checkall');
        deleteItemsRef.current.classList.add('d-none');
    }, [page]);

    const note = labels?.tabs.find((tab, i) => (tab.slug === slug) || (slug === 'inbox' && i === 0))?.description;

    const handleSearch = (ele) => {
        setPage(1)
        setSearch(ele.target.value)
    };

    useEffect(() => {
        if(data && data.rows) {
            data.rows = data?.rows.filter((m) => m.id !== moveId);
        }
    }, [data, moveId])

    const handleCheckItem = (ele, msg_id) => {
        setCheckedItems([...checkedItems, msg_id])
        deleteItemsRef.current.classList.remove('d-none');
    }

    return (
        <div className={"mailbox " + (mailItemOpen ? 'open' : '') +  (search.length > 0 ? ' search-box' : '')}>
            <div className="mailbox-header">
                <a href="/" className="mailbox-menu"><i className="ri-menu-2-fill"></i></a>
                <div className="mailbox-search">
                    <i className="ri-search-line"></i>
                    <input type="search" className="form-control" placeholder="Search message" onChange={(ele) => handleSearch(ele)}/>
                </div>
                <a href="/" className="mail-avatar">
                    <Avatar row={user}/>
                </a>
            </div>

            <div className="mailbox-option">
                <div className="mailbox-select dropdown">
                    <a className="dropdown-check" ref={checkAllRef} onClick={handleCheckAll}>
                        <i className="ri-checkbox-blank-line"></i>
                        <i className="ri-checkbox-line"></i>
                        <i className="ri-checkbox-indeterminate-fill"></i>
                    </a>
                    <a className="dropdown-link" data-bs-toggle="dropdown">
                        <i className="ri-arrow-down-s-line"></i>
                    </a>
                    <div className="dropdown-menu">
                        <a href="" className="dropdown-item all active"><i className="ri-check-fill"></i> All</a>
                        <a href="" className="dropdown-item read"><i className="ri-check-line"></i> Read</a>
                        <a href="" className="dropdown-item unread"><i className="ri-check-line"></i> Unread</a>
                    </div>

                    <a className="dropdown-check" onClick={() => refetch()}><i className="ri-refresh-line"></i></a>
                    <a className="dropdown-check delete-selected d-none" onClick={handleDelete} ref={deleteItemsRef}><i
                        className="ri-delete-bin-2-line"></i></a>
                </div>
                <div className="ms-auto d-flex align-items-center">
                    <span>{`${numeral(meta?.from).format('0,0')}-${numeral(meta?.to).format('0,0')} of ${numeral(meta?.total).format('0,0')}`}</span>
                    <a onClick={() => setPage(meta?.prev_page)} className="pager prev"><i
                        className="ri-arrow-left-s-line"></i></a>
                    <a onClick={() => setPage(meta?.next_page)} className="pager next"><i
                        className="ri-arrow-right-s-line"></i></a>
                </div>
            </div>

            {search.length === 0 && ['', 'inbox', ...labels?.tabs.map((tab) => tab.slug)].includes(slug) &&
                <ul className={"nav -nav-pills mailbox-tabs " + (mailItemOpen ? 'd-none' : '')}>
                    {labels?.tabs?.map((item, i) => (
                        <li className="nav-item" key={i}>
                            <Link to={`/${item.slug}`}
                                  className={`nav-link ${((item.slug === slug) || (slug === 'inbox' && i === 0) ? `active` : '')}`}
                                  style={{borderColor: item.color}}>
                                <i className={`${item?.icon}`} style={{color: item.color}}></i>
                                <span className="tab-label">{item.label}</span>
                                {item.total > 0 &&
                                    <small className="badge -bg-success ms-2"
                                           style={{backgroundColor: item.color}}>{numeral(item.total).format('0,0')}</small>
                                }
                                <br/><small className="text-black" dangerouslySetInnerHTML={{__html: item.tag_line}}/>
                            </Link>
                        </li>
                    ))}
                </ul>
            }

            {isLoading &&
                <div className="d-flex justify-content-center justify-align-center">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                    <strong role="status">Loading...</strong>
                </div>
            }

            {search.length === 0 && note &&
                <div className="alert alert-warning d-flex align-items-center tab-description m-0" role="alert">
                    <i className="ri-error-warning-line ri-2x"></i>
                    <div>{note}</div>
                </div>
            }
            {search.length > 0 &&
                <div className="row justify-content-center mb-2">
                    <div className="col-6">
                        <div className="alert alert-info d-flex align-items-center tab-description m-0" role="alert">
                            <i className="ri-search-line ri-2x"></i>
                            <div><b>Search:</b> {search}</div>
                        </div>
                    </div>
                </div>
            }

            {data?.meta.total === 0 &&
                <div className="row justify-content-center">
                    <div className="col-6">
                        <div className="alert alert-info d-flex align-items-center tab-description p-2" role="alert">
                            <i className="ri-error-warning-line ri-2x"></i>
                            <div>{data.message}</div>
                        </div>
                    </div>
                </div>
            }

            <ul id="mailGroup" className="mail-group" ref={mailItemsRef}>
                {data?.rows?.map((msg, i) => (
                    <MailItem
                        key={i}
                        avatar={(msg.isAvatar ? msg.avatar : msg.color.backgroundColor)}
                        sender={msg.display_name}
                        time={msg.date}
                        subject={msg.subject}
                        text={msg.short_msg}
                        unread={(msg.status === 'Unread' /*msg.id !== mailID*/)}
                        msg={msg}
                        onClick={(ele) => handleItem(ele, msg.id)}
                        onCheck={handleCheckItem}
                    />
                ))}
            </ul>

        </div>
    );
};

export default Mailbox;